import { render, staticRenderFns } from "./draft-list.vue?vue&type=template&id=0a4530f3&scoped=true&"
import script from "./draft-list.vue?vue&type=script&lang=js&"
export * from "./draft-list.vue?vue&type=script&lang=js&"
import style0 from "./draft-list.vue?vue&type=style&index=0&id=0a4530f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4530f3",
  null
  
)

export default component.exports